import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import adminSlice from "src/components/pages/admin/store/adminSlice";
import chatSlice from "src/components/pages/home/store/chatSlice";
import errorBoundarySlice from "src/store/errorBoundarySlice";
import toastsSlice from "src/store/toastsSlice";
import userSlice from "src/store/userSlice";

export const reducers = {
  user: userSlice,
  toasts: toastsSlice,
  errorBoundary: errorBoundarySlice,
  chatSlice: chatSlice,
  adminSlice: adminSlice,
};

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // to allow non serializable objects to be stored in redux (eg: Map, Set, classes etc.)
    }),
});
export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
